import type {LabelHTMLAttributes, ReactNode} from 'react'
import {cn} from '../../lib/utils'

interface MonoLabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
    children: ReactNode
}

export function MonoLabel({className, children, ...rest}: MonoLabelProps) {
    return (
        <label
            {...rest}
            className={cn(
                'font-mono text-[10px] tracking-[0.2em] uppercase text-foreground/50',
                className
            )}
        >
            {children}
        </label>
    )
}
